import { h, Component } from "preact";
import Button from "./Button";
import { css } from "emotion";
import config from "../config";
const footerBox = css({
  padding: "12px 16px",
  borderRadius: 4,
  maxWidth: 800,
  width: "100%",
  backgroundColor: "#fafafa",
  marginTop: 24,
  display: "flex",
  justifyContent: "center"
});
const WhatToDoNext = ({}) => {
  return (
    <div className={footerBox}>
      <div style={{ width: 400 }}>
        <h2>Wondering what to do later?</h2>
        <p>
          Be inspired, entertained and educated by the incredible lineup of
          events on Humanitix.
        </p>
        <Button link={`${config("WEBSITE_URL")}/au/search`} type="primary">
          Explore events
        </Button>
      </div>
    </div>
  );
};

export default WhatToDoNext;



// WEBPACK FOOTER //
// ./components/WhatToDoNext.js